<template>
  <div class="contentBox">
    <!-- 表格数据 -->
    <div class="tableBox">
      <!-- 机构管理-->
      <div class="innovationVoucher">
        <img src="@/assets/images/table-tab.png" width="8px" height="23px" />
        <span>机构管理</span>
      </div>
      <!-- Tabs标签组件 -->
      <Tabs :tabs="tabsList" @tab-click="tabClick">
        <!-- 搜索条件 -->
        <jr-search :params="searchParams" @search="handleSearch" @reset="handleSearch"></jr-search>
        <template v-slot:button>
          <div v-if="rightbutton">
            <el-button size="medium" type="primary" @click="addexmaterials('add')" icon="el-icon-circle-plus-outline">新增机构</el-button>
            <el-button size="medium" type="success" @click="exportEjJg()" icon="el-icon-folder">导入机构</el-button>
          </div>
          <div v-else style="display: flex; align-items: center; justify-content: center">
            <el-button size="mini" type="primary" @click="addexmaterials('edit')">申请修改机构信息</el-button>
          </div>
        </template>
        <template v-if="currentUsersData.length">
          <JRtable
            :table-data="currentUsersData"
            :selection="false"
            :show-pagination="true"
            :column="currentUsersColumns"
            size="mini"
            :border="true"
            :pageOptions="pageOptions"
            @page-change="handlePageChange"
            :index="true"
          >
            <template slot="slot_record_tools" slot-scope="data">
              <el-button @click="handleViewRedemptionDetails(data.scope.row, '查看')" size="mini" type="primary" icon="el-icon-view">查看</el-button>
              <el-button @click="handleViewRedemptionDetails(data.scope.row, '修改')" size="mini" type="success" icon="el-icon-edit">修改</el-button>
              <el-button
                @click="handleViewRedemptionDetails(data.scope.row, '删除')"
                size="mini"
                type="danger"
                icon="el-icon-delete"
                :disabled="data.scope.row.jgshzt === '111' || data.scope.row.jgshzt === '009'"
                >删除</el-button
              >
            </template>
          </JRtable>
        </template>
        <template v-else>
          <div style="color: #333333; font-weight: 400; width: 64px; height: 30px; margin: 30px">暂无数据</div>
        </template>
      </Tabs>
      <!-- 机构信息修改申请弹窗表单 -->
      <Dialog :visible.sync="showDialog" width="1430px" :title="title" :showBtn="false" @close="showDialog = false" :append-to-body="true">
        <template #content>
          <div class="applyform">
            <el-form :model="preexchangeForm" :rules="ruleExchangeForm" ref="ruleForm" label-width="100px" class="demo-ruleForm">
              <el-card class="box-cards">
                <div slot="header" class="card-title">
                  <div></div>
                  <span style="width: 150px">机构基本信息</span>
                </div>
                <el-row v-if="title === '新增机构信息'">
                  <el-col :span="24" style="margin: 15px">
                    <span style="color: red; margin-left: 10px; font-weight: bold; font-size: 15px">
                      （提示：1、大学：按“XXXX大学XXXX学院”开通帐号。2、国家实验室、全国重点实验室和湖北实验室：按“XXXX实验室”开通帐号。3、院所：按“XXXX院XXXX所”或“XXXX院”开通帐号）</span
                    >
                  </el-col>
                </el-row>
                <el-row :gutter="20">
                  <el-col :span="12">
                    <el-form-item label="机构名称：" prop="jgmc" label-width="150px">
                      <el-input v-model.trim="preexchangeForm.jgmc" style="width: 350px" clearable :readonly="operation"></el-input> </el-form-item
                  ></el-col>
                  <el-col :span="12">
                    <el-form-item label="法人单位统一社会信用代码：" label-width="210px">
                      <el-input v-model.trim="preexchangeForm.tyshxydm" style="width: 350px" clearable disabled></el-input> </el-form-item
                  ></el-col>
                </el-row>
                <el-row :gutter="20">
                  <el-col :span="12">
                    <el-form-item label="机构联系人：" prop="jglxr" label-width="150px">
                      <el-input v-model.trim="preexchangeForm.jglxr" style="width: 350px" clearable :readonly="operation"></el-input> </el-form-item
                  ></el-col>
                  <el-col :span="12">
                    <el-form-item label="机构联系人电话：" prop="jglxrdh" label-width="150px">
                      <el-input v-model.trim="preexchangeForm.jglxrdh" style="width: 350px" clearable :readonly="operation"></el-input> </el-form-item
                  ></el-col>
                </el-row>
                <el-row :gutter="20">
                  <el-col :span="12">
                    <el-form-item label="办公电话：" prop="bgdh" label-width="150px">
                      <el-input v-model.trim="preexchangeForm.bgdh" style="width: 350px" clearable :readonly="operation"></el-input>
                      <span style="color: red; margin-left: 5px" v-if="title !== '机构信息'">例如：027-88888888</span>
                    </el-form-item></el-col
                  >
                  <el-col :span="12">
                    <el-form-item label="登录账号：" label-width="150px">
                      <el-input v-model.trim="preexchangeForm.wyzh" style="width: 350px" clearable disabled placeholder="不可填写,添加后系统自动生成账号"></el-input> </el-form-item
                  ></el-col>
                </el-row>
                <el-row :gutter="20">
                  <el-col :span="24">
                    <el-form-item label="初始密码：" prop="password" label-width="150px" style="margin-bottom: 0px">
                      <el-input v-model.trim="preexchangeForm.password" style="width: 350px" clearable :readonly="operation" type="password" auto-complete="new-password"  placeholder="如果不填写,默认密码与登录账号一致"></el-input>
                      <span style="color: red; margin-left: 10px" v-if="title !== '新增机构信息'">(默认密码与账号一致)</span>
                    </el-form-item>
                  </el-col>
                </el-row>
                <br />
                <br />
                <el-row :gutter="20" type="flex" justify="center">
                  <el-button type="primary" size="medium" @click="submit" v-if="!operation">提交</el-button>
                  <el-button size="medium" @click="cancel">关闭</el-button>
                </el-row>
              </el-card>
              <!-- <el-card class="box-cards" v-if="false">
                <div slot="header" class="card-title">
                  <div></div>
                  <span>附件上传</span>
                  <span style="color: red; font-weight: 800; margin-left: 10px; font-size: 15px"
                    >注：以下材料均需要清晰，并按以下各项附件栏目提示要求加盖公章。（上传附件请提供pdf格式文件,可上传多个文件）</span
                  >
                </div>
                <el-row :gutter="20" v-for="(item, index) in wjlxList" :key="item.dictCode" class="upload-attachments">
                  <el-col :span="6"
                    ><span class="upload-title">{{ index + 1 }}、{{ item.dictValue }}</span></el-col
                  >
                  <el-col :span="10" style="display: flex; flex-direction: column">
                    <el-upload
                      class="upload-demo"
                      ref="uploadFile"
                      :action="upload.action"
                      :headers="upload.token"
                      :on-preview="handlePreview"
                      :on-remove="handleRemove"
                      :before-remove="beforeRemove"
                      :limit="1"
                      :show-file-list="false"
                      :before-upload="beforeAvatarUpload"
                      :on-success="
                        (response, file, fileList) => {
                          return handUploadFileSuccess(response, file, fileList, index)
                        }
                      "
                      :on-error="handUploadFileError"
                      :data="{ jgid: uuid, wjlx: item.dictCode }"
                      accept=".pdf"
                      :disabled="operation"
                    >
                      <span class="upload-icon" v-if="item.fileList.length != 3"><i class="el-icon-upload2"></i>上传</span>
                    </el-upload>
                    <div class="up-list_item">
                      <div class="up-list_item_row" v-for="(item2, index2) in item.fileList" :key="index2">
                        <div class="fileName">
                          <el-link type="success" icon="el-icon-document" :underline="false">{{ item2.wjm }} （{{ item2.wbdx | bytesToKB }}）</el-link>
                        </div>
                        <div class="fileTools">
                          <el-button size="small" type="text" class="text-danger" @click="removeFile(item2.fjid)" :disabled="operation">删除 </el-button>
                          <el-button size="small" type="text" @click="previewFile(item2.fjid)">预览 </el-button>
                          <el-button size="small" type="text" @click="downloadFile(item2.fjid)">下载</el-button>
                        </div>
                      </div>
                    </div>
                  </el-col>
                  <el-col :span="8">
                    <div>
                      <span class="upload-waring">{{ item.remark }}</span>
                      <br />
                      <span style="color: rgb(86, 165, 253); text-decoration: underline; cursor: pointer; font-size: 16px" @click="handleDownTemplate(item)">{{ item.auxiliaryValue }}</span>
                    </div>
                  </el-col>
                </el-row>
                <el-row :gutter="20" type="flex" justify="center">
                  <el-button type="primary" size="medium" @click="submit" v-if="!operation">提交</el-button>
                  <el-button size="medium" @click="cancel" type="success">取消</el-button>
                </el-row>
              </el-card> -->
            </el-form>
          </div>
        </template>
      </Dialog>

      <!-- 批量导入 -->
      <Dialog
        :visible.sync="showFileDialog"
        width="700px"
        title="机构批量导入"
        :showBtn="true"
        @close=";(showFileDialog = false), (fileList = [])"
        :append-to-body="true"
        @confirm="handelFileUpLoad"
        @cancel=";(showFileDialog = false), (fileList = [])"
      >
        <template #content>
          <el-card class="box-cards">
            <div slot="header" class="card-title">
              <span>机构导入模板：<el-link type="primary" @click="handleDownloadFile">点击下载</el-link></span>
              <br />
              <span style="color: red">*系统会自动过滤空格 模版中的字段都为必填，否则无法导入</span>
            </div>
            <el-upload
              class="upload-demo"
              action="#"
              :before-upload="beforeFileUpload"
              :on-remove="handleRemove"
              accept=".xlsx,.xls"
              :on-change="handSecondFileSuccess"
              :auto-upload="false"
              :limit="1"
              :file-list="fileList"
            >
              <el-button size="small" type="primary">点击上传</el-button>
              <div slot="tip" class="el-upload__tip">只能上传.xlsx/.xls文件</div>
            </el-upload>
          </el-card>
        </template>
      </Dialog>
    </div>
  </div>
</template>

<script>
import JRtable from '@/components/Table'
import Tabs from '@/components/Tabs'
import Dialog from '@/views/enterprise/components/Dialog'
import { getDictionaryList, recursionDictData } from '@/api/enterprise/exchangelist'
import { pageMySecondJg, saveSecondJg, secondJgDetail, updateSecondJg, deleteSecondJg, postSecondUpload } from '@/api/mechanism/mySecondJg/index.js'
import { getJgFileList, removeFileRecord, printPdfView, downloadFileRecord } from '@/api/mechanism/enterApply'
import { validateMobile, validateEmail, validateOfficTelephone } from '@/utils/jr-validate'
import { downloadFileTemplateManage } from '@/api/index.js'
import { getToken } from '@/utils/cache'
import { getUuid } from '@/utils'
import { validateStrongPassword } from '@/utils/jr-validate'
import JrSearch from '@/components/Search'
export default {
  components: {
    JRtable,
    Tabs,
    Dialog,
    'jr-search': JrSearch
  },
  created() {
    // 获取字典类型
    // this.getDictionaryList()
    // 分页查询我的二级机构信息
    this.pageMySecondJg()
    // 查询地址字典信息
    this.handleGetHbDivision()
  },
  filters: {
    bytesToKB: function (bytes) {
      if (bytes === 0) return '0 Bytes'
      const k = 1024
      let size = bytes / k
      let unit = 'KB'
      if (size > k) {
        size /= k
        unit = 'MB'
      }
      return size.toFixed(2) + ' ' + unit
    }
  },
  data() {
    return {
      searchParams: [
        { type: 'input', field: 'jgmc', label: '机构名称' },
        { type: 'input', field: 'wyzh', label: '账号名称' }
        // { type: 'input', field: 'fwmc', label: '服务名称' },
      ],
      searchForm: {},
      // 分页数据
      pageOptions: {
        page: 1,
        limit: 10,
        total: 0
      },
      divisionHbDictList: [],
      cityDictProps: {
        label: 'dictValue',
        value: 'dictCode',
        children: 'childSysDictionaryList'
      },
      // 表格数据
      currentUsersData: [],
      currentUsersColumns: [
        {
          label: '机构名称',
          prop: 'jgmc',
          align: 'center',
          // width: '300',
          truncate: true
        },
        {
          label: '账号名称',
          prop: 'wyzh',
          align: 'center',
          // width: '300',
          truncate: true
        },
        {
          label: '办公电话',
          prop: 'bgdh',
          align: 'center',
          // width: '300',
          truncate: true
        },
        // {
        //   label: '审核状态',
        //   prop: 'jgshztName',
        //   align: 'center',
        //   truncate: true
        // },
        // {
        //   label: '申请时间',
        //   prop: 'sqrzrq',
        //   align: 'center',
        //   truncate: true
        // },
        {
          label: '操作',
          prop: 'id4',
          align: 'center',
          slot: 'slot_record_tools'
        }
      ],
      // 顶部横向tabs切换栏目
      tabsList: [
        // {
        //   id: 0,
        //   value: '机构信息管理',
        //   isActive: true,
        //   // quantity: 0,
        //   permission: ['编辑', '查看']
        // }
        // {
        //   id: 1,
        //   value: '机构信息修改申请',
        //   isActive: false,
        //   quantity: 0,
        //   permission: ['查看']
        // }
      ],
      // 是否显示dialog
      showDialog: false,
      // 机构信息表单对应的form信息
      preexchangeForm: {
        // 机构名称
        jgmc: '',
        // 机构联系人
        jglxr: '',
        // 机构联系人电话
        jglxrdh: '',
        // 邮箱
        yx: '',
        // 二级单位机构代码
        tyshxydm: this.$store.state.user.tyshxydm,
        // 通讯地址
        jgdz: [],
        txdz: '',
        // 统计表导入
        approval_exchange_amount: '',
        // 账号
        wyzh: '',
        // 密码
        password: ''
      },
      // 机构信息表 所需的 form 验证规则
      ruleExchangeForm: {
        // 机构名称：
        jgmc: [{ required: true, message: '请输入机构名称', trigger: 'blur' }],
        // 兑付总金额（万元）：
        jglxr: [{ required: true, message: '请输入机构联系人', trigger: 'blur' }],
        // 机构联系人电话
        jglxrdh: [
          { required: true, message: '请输入机构联系人电话', trigger: 'blur' },
          { validator: validateMobile, trigger: 'blur' }
        ],
        // 邮箱
        yx: [
          { required: true, message: '请输入邮箱', trigger: 'blur' },
          { validator: validateEmail, trigger: 'blur' }
        ],
        // 通讯地址
        jgdz: [{ required: true, message: '请输入通讯地址', trigger: 'change' }],
        // 账号
        wyzh: [{ required: true, message: '请输入账号', trigger: 'blur' }],
        // 密码
        password: [
          { required: false, message: '请输入密码', trigger: 'blur' },
          // { validator: validateStrongPassword, trigger: 'blur' }
        ],
        // 办公电话
        bgdh: [
          { required: true, message: '请输入办公电话', trigger: 'change' },
          { validator: validateOfficTelephone, trigger: 'change' }
        ]
      },
      // 下拉框选择的数据
      selecteValue: '',
      // 下拉框的数据
      options: [],
      // 输入框数据
      inputValue: '',
      // 右侧展示
      rightbutton: true,
      // 表单标题
      title: '新增机构信息',
      // 文件列表信息
      wjlxList: [],
      // 当前token
      upload: {
        action: process.env.VUE_APP_BASE_API + process.env.VUE_APP_PREFIX_API_SC + '/ticketMain/api/factJgjbxxb/uploadJgrzsqFile',
        token: {
          Internettoken: getToken()
        }
      },
      // 当前的uuid
      uuid: '',
      // 是否有权限操作，默认有
      operation: false,
      showFileDialog: false, //展示导入文件弹窗
      fileList: [] //导入文件列表
    }
  },
  methods: {
    // 搜索条件
    handleSearch(param) {
      this.pageOptions.page = 1
      this.pageOptions.limit = 10
      this.searchForm = { ...param }
      this.pageMySecondJg()
    },
    // 分页查询兑付记录
    async pageMySecondJg() {
      let params = {
        page: this.pageOptions.page,
        size: this.pageOptions.limit,
        ...this.searchForm
      }
      const result = await pageMySecondJg(params)
      if (result.code === 200) {
        this.currentUsersData = result.data.records
        this.pageOptions.total = result.data.total
        // this.tabsList[0].quantity = result.data.total
      } else {
        this.currentUsersData = []
        this.pageOptions.total = 0
        // this.tabsList[0].quantity = 0
      }
    },
    // 分页控制
    handlePageChange(val) {
      this.pageOptions.page = val.page
      this.pageOptions.limit = val.limit
      // 再次获取数据
      this.pageMySecondJg()
    },
    // 查询湖北省行政区划
    handleGetHbDivision() {
      let params = {
        parentId: '420000',
        level: '3'
      }
      recursionDictData(params).then((response) => {
        const { data } = response
        this.divisionHbDictList.push(data)
      })
    },
    // 选择级联地址
    handleChange() {
      const pathLabels = this.$refs.fAddress.getCheckedNodes()[0].pathLabels
      this.preexchangeForm.txdz = pathLabels.join('').replaceAll('省直辖县级行政区划', '')
    },
    // 获取字典类型数据
    async getDictionaryList() {
      // 附件上传文件类型
      let wjList = await getDictionaryList({
        parentCode: 'DIM_WJLX'
      })
      if (wjList.code === 200) {
        this.wjlxList = wjList.data.filter((item) => {
          return item.dictCode === '006' || item.dictCode === '026' || item.dictCode === '027' || item.dictCode === '025'
        })
        this.wjlxList.forEach((element) => {
          this.$set(element, 'fileList', [])
        })
      }
    },
    // 点击查看详情
    async handleViewRedemptionDetails(val, status) {
      this.uuid = val.jgid
      if (status === '查看') {
        const result = await secondJgDetail({ jgid: val.jgid })
        if (result.code === 200) {
          this.preexchangeForm = result.data
          // 回显地址
          if (result.data.jgszs === null) {
            this.$set(this.preexchangeForm, 'jgdz', [])
          } else {
            this.$set(this.preexchangeForm, 'jgdz', ['420000', result.data.jgszs, result.data.jgszqy])
          }
          // 回显上传文件的信息
          this.getExchangeListAttach(val.jgid)
        } else {
          this.preexchangeForm = {}
          this.$message.error('系统异常，请稍后再试')
        }
        this.title = '机构信息'
        this.operation = true
        this.showDialog = true
      } else if (status === '修改') {
        const result = await secondJgDetail({ jgid: val.jgid })
        if (result.code === 200) {
          this.preexchangeForm = result.data
          // 回显地址
          if (result.data.jgszs === null) {
            this.$set(this.preexchangeForm, 'jgdz', [])
          } else {
            this.$set(this.preexchangeForm, 'jgdz', ['420000', result.data.jgszs, result.data.jgszqy])
          }
          // 回显上传文件的信息
          this.getExchangeListAttach(val.jgid)
        } else {
          this.preexchangeForm = {}
          this.$message.error('系统异常，请稍后再试')
        }
        this.title = '修改机构信息'
        this.operation = false
        this.showDialog = true
      } else if (status === '删除') {
        this.removeInfo(val)
      }
    },
    // tabs栏目点击切换事件
    tabClick() {
      // 再次获取数据
      this.pageMySecondJg()
    },
    // 导入二级机构信息
    exportEjJg() {
      this.showFileDialog = true
      // this.$message.success('导入二级单位')
    },
    handSecondFileSuccess(file, fileList) {
      this.fileList = fileList
    },
    async handelFileUpLoad(file) {
      if (this.fileList.length === 0) {
        this.$message.error('请选择文件')
        return
      }
      if (!this.beforeFileUpload(this.fileList[0].raw)) return
      const formData = new FormData()
      formData.append('file', this.fileList[0].raw)
      const axios = require('axios')

      axios
        .post(process.env.VUE_APP_BASE_API + 'sc/ticketMain/api/factJgjbxxb/secondExcelRead', formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
            Internettoken: getToken()
          }
        })
        .then((res) => {
          if (res.data.code === 200) {
            this.$message.success('导入成功')
            this.showFileDialog = false
            this.fileList = []
            this.pageMySecondJg()
          } else {
            this.$message.error('导入失败')
          }
        })
        .catch((error) => {
          console.error('上传失败:', error)
        })
    },
    handleDownloadFile(rw) {
      window.location.href = downloadFileTemplateManage('1d3823af39a34abf8187ffb4bec4e247')
    },
    beforeFileUpload(file) {
      const validTypes = ['.xlsx', '.xls']
      const fileType = file.name.slice(file.name.lastIndexOf('.'))
      if (!validTypes.includes(fileType)) {
        this.$message.error('请上传对应的文件类型')
        return false
      }
      return true
    },
    // 点击新增材料
    addexmaterials(type) {
      if (type === 'add') {
        this.title = '新增机构信息'
        this.operation = false
      } else {
        this.title = '修改机构信息'
        this.operation = false
      }
      // 创建的一个uuid
      this.uuid = getUuid()
      this.showDialog = true
    },
    // 提交信息
    submit() {
      // 表单验证
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          // if (!this.preexchangeForm.jgdz.length > 0) {
          //   this.$message.warning('请选择机构所在地')
          //   return false
          // }
          // 表单提交成功，做一些操作
          this.submitApplyPost()
        } else {
          // 表单验证失败，做一些操作
          this.$message.warning('表单校验未通过，请重新填写再提交')
          return false
        }
      })
    },
    // 提交表单信息
    async submitApplyPost() {
      const list = { ...this.preexchangeForm }
      // 当前的uuid
      list.jgid = this.uuid
      list.tyshxydm = this.$store.state.user.tyshxydm
      // 需要处理机构地址
      if (list.jgdz.length > 0) {
        list.jgszs = list.jgdz[1]
        list.jgszqy = list.jgdz[2]
      } else {
        list.jgszs = ''
        list.jgszqy = ''
      }
      if (this.title === '修改机构信息') {
        const result = await updateSecondJg(list)
        if (result.code == 200) {
          this.showDialog = false
          // 在获取一遍数据
          this.pageMySecondJg()
          this.$message.success('操作成功')
        } else {
          this.$message.error(result.message)
        }
      } else if (this.title === '新增机构信息') {
        const result = await saveSecondJg(list)
        if (result.code == 200) {
          this.showDialog = false
          // 在获取一遍数据
          this.pageMySecondJg()
          this.$message.success('操作成功')
        } else {
          this.$message.error(result.message)
        }
      }
    },
    // 删除表单信息
    removeInfo(val) {
      this.$confirm('确定删除该条信息?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(async () => {
          const result = await deleteSecondJg({ jgid: val.jgid })
          this.$message({
            type: 'success',
            message: '删除成功'
          })
          this.pageMySecondJg()
        })
        .catch(() => {
          console.log('取消删除')
        })
    },
    // 关闭表单，清除校验
    cancel() {
      this.showDialog = false
    },
    handlePreview(file) {
      console.log(file)
    },
    handleRemove(file, fileList) {
      console.log('handleRemove', file, fileList)
      this.fileList = []
    },
    // 上传失败
    handUploadFileError() {
      this.$message.error('上传失败')
    },
    //删除文件
    removeFile(fileId) {
      this.$modal
        .confirm('是否删除该附件')
        .then(function () {
          return removeFileRecord({ fileId: fileId })
        })
        .then((res) => {
          // 成功之后
          if (res.code === 200) {
            if (res.data == '操作成功') {
              this.$message.success('删除成功')
              this.getExchangeListAttach(this.uuid)
            } else {
              this.$message.error('删除失败')
            }
          }
        })
    },
    // 预览文件
    previewFile(fileId) {
      let params = {
        fileId,
        InternetToken: getToken()
      }
      var paramsStr = Object.keys(params)
        .map((item) => item + '=' + params[item])
        .join('&')
      //预览文件
      window.open(printPdfView(paramsStr))
    },
    // 下载文件
    downloadFile(fileId) {
      let params = {
        fileId,
        InternetToken: getToken()
      }
      var paramsStr = Object.keys(params)
        .map((item) => item + '=' + params[item])
        .join('&')
      window.open(downloadFileRecord(paramsStr), '_blank')
    },
    beforeRemove(file, fileList) {
      if (file && file.status == 'success') {
        return this.$confirm(`确定移除 ${file.name}？`)
      }
    }, // 限制不超过4M
    beforeAvatarUpload(file) {
      const isPDF = file.type === 'application/pdf'
      const isLt5M = file.size / 1024 / 1024 < 4
      if (!isPDF) {
        this.$message.error('上传附件只能是 PDF 格式!')
      }
      if (!isLt5M) {
        this.$message.error('上传pdf文件不能超过 4MB!')
      }
      return isPDF && isLt5M
    },
    // 上传文件成功
    handUploadFileSuccess(response, file, fileList, index) {
      if (response && response.code === 200) {
        this.$message.success('上传成功')
        // 回传事件，进行附件记录的更新
        this.getExchangeListAttach(this.uuid)
        // 清空当前已上传的文件列表
        this.$refs.uploadFile[index].clearFiles()
      } else {
        this.$message.error('上传失败')
      }
    },
    // 查看兑付详情所有的附件
    async getExchangeListAttach(val) {
      const result = await getJgFileList({
        jgid: val
      })
      const { data } = result
      if (data.length == 0) {
        this.wjlxList.forEach((element) => {
          this.$set(element, 'fileList', [])
        })
        return
      } else {
        this.wjlxList = this.mergeFilesByCode(this.wjlxList, data, 'dictCode', 'wjlx')
      }
    },
    // 定义一个函数来将 dataList 添加到 wjlxList 的 fileList 中
    mergeFilesByCode(wjlxList, dataList, dictCodeKey, wjlxKey) {
      // 将 dataList 按照 wjlx 分组
      const groupedData = dataList.reduce((acc, obj) => {
        const key = obj[wjlxKey]
        if (!acc[key]) {
          acc[key] = []
        }
        acc[key].push(obj)
        return acc
      }, {})

      // 遍历 wjlxList，将对应的 fileList 填充
      wjlxList.forEach((item) => {
        const wjlx = item[dictCodeKey]
        if (groupedData[wjlx]) {
          this.$set(
            item,
            'fileList',
            groupedData[wjlx].map((obj) => {
              return obj
            })
          )
        } else {
          this.$set(item, 'fileList', [])
        }
      })

      return wjlxList
    }
  },
  watch: {
    showDialog: {
      handler: function (value) {
        if (!value) {
          // 清空数据
          this.preexchangeForm = {
            // 机构名称
            jgmc: '',
            // 机构联系人
            jglxr: '',
            // 机构联系人电话
            jglxrdh: '',
            // 邮箱
            yx: '',
            // 统一社会信用代码
            tyshxydm: this.$store.state.user.tyshxydm,
            // 通讯地址
            jgdz: [],
            txdz: '',
            // 统计表导入
            approval_exchange_amount: '',
            // 账号
            wyzh: '',
            // 密码
            password: ''
          }
          // 清空uuid
          this.uuid = ''
          //清除所有表单项的验证提示信息
          this.$nextTick(() => {
            this.$refs.ruleForm.clearValidate()
          })
          // 清空文件，都为空数组
          this.wjlxList.forEach((element) => {
            this.$set(element, 'fileList', [])
          })
        }
      },
      deep: true
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/styles/form.scss';

.contentBox {
  width: 100%;
  height: 100%;

  .tableBox {
    margin-top: 25px;
  }
}

.innovationVoucher {
  font-weight: bold;
  display: flex;
  font-size: 20px;
  color: #333333;
  margin-bottom: 15px;

  span {
    margin-left: 10px;
  }

  :nth-child(3) {
    font-size: 16px;
    font-weight: bold;
    color: #ff0000;
    margin-left: 15px;
  }
}

.tabs-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 34px;

  .left {
    display: flex;

    :nth-child(1) {
      display: flex;
      justify-content: center;
      align-items: center;
      height: 29px;
      padding: 5px;
      opacity: 0.75;
      background: #3f7fff;
    }

    :nth-child(2) {
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 16px;
      font-weight: bold;
      color: #333333;
      margin-left: 17px;
    }
  }

  .right {
    display: flex;

    :nth-child(1) {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 70px;
      height: 30px;
      border-radius: 5px 5px 5px 5px;
      background: #adadad;
      margin-right: 10px;
      cursor: pointer;
    }

    :nth-child(2) {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 70px;
      height: 30px;
      border-radius: 5px 5px 5px 5px;
      background: #3f7fff;
      cursor: pointer;
    }
  }
}

.table-container {
  padding: 15px;
  border: 1px solid rgb(243, 247, 255) !important;
  background: rgb(252, 252, 252);
  margin-top: 15px !important;
  margin-bottom: 0px !important;
}

// 企业兑付申请表单样式
.applyform {
  padding: 10px;

  .box-cards {
    margin-bottom: 10px;

    .card-title {
      display: flex;
      align-items: center;

      div {
        width: 5px;
        height: 13px;
        background: rgb(88, 155, 248);
        margin-right: 10px;
      }

      span {
        font-size: 18px;
        font-weight: bold;
      }
    }
  }
}

::v-deep .el-form {
  .el-form-item {
    display: flex;
  }

  .el-form-item__content {
    margin-left: 10px !important;
  }
}

::v-deep.upload-attachments.el-row {
  min-height: 100px;
  display: flex;
  align-items: center;

  .upload-title {
    font-weight: 800;
    font-size: 15px;
    color: #606266;
  }

  .upload-icon {
    cursor: pointer;
    font-size: 15px;
    color: rgb(86, 165, 253);

    i {
      margin-right: 5px;
    }
  }

  .upload-waring {
    color: red;
    font-size: 15px;
  }
}

.up-list_item {
  background: rgba(144, 161, 183, 0.06);

  .up-list_item_row {
    display: flex;
    justify-content: space-between;
    align-items: center;

    &:hover {
      background: #f4f5f5;
    }

    .fileName .el-link {
      font-size: 15px;
    }
  }
}
</style>
